import NoDeals from './NoDeals';

export default NoDeals;
